// Ported from cartadigital-pos app/utils/order-type-policies.ts.
import { OrderType } from '@/enums/OrderEnums';

export interface IBranchOrderPolicyFlags {
  allowOrders: boolean | null;
  tableOrders: boolean | null;
  takeAway: boolean | null;
  delivery: boolean | null;
}

export const ORDER_TYPE_PRIORITY: readonly OrderType[] = [
  OrderType.Seat,
  OrderType.Away,
  OrderType.Delivery,
];

/**
 * Order type is considered enabled unless its policy is explicitly `false`.
 * (null means "unknown" and is treated as enabled to avoid premature blocking).
 */
export function isOrderTypeEnabled(
  flags: Pick<IBranchOrderPolicyFlags, 'tableOrders' | 'takeAway' | 'delivery'>,
  type: OrderType
): boolean {
  if (type === OrderType.Seat) return flags.tableOrders !== false;
  if (type === OrderType.Away) return flags.takeAway !== false;
  if (type === OrderType.Delivery) return flags.delivery !== false;
  return true;
}

export function listEnabledOrderTypes(
  flags: Pick<IBranchOrderPolicyFlags, 'tableOrders' | 'takeAway' | 'delivery'>
): OrderType[] {
  const out: OrderType[] = [];
  for (const t of ORDER_TYPE_PRIORITY) {
    if (isOrderTypeEnabled(flags, t)) out.push(t);
  }
  return out;
}

export function resolveAllowedOrderType(
  flags: Pick<IBranchOrderPolicyFlags, 'tableOrders' | 'takeAway' | 'delivery'>,
  preferred: OrderType
): OrderType | null {
  if (isOrderTypeEnabled(flags, preferred)) return preferred;
  const enabled = listEnabledOrderTypes(flags);
  return enabled[0] ?? null;
}
